/*
 * File: TeamDetails
 * Project: a-a
 * File Created: Monday, 20th January 2025 7:49:22 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 24th July 2025 9:19:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../theme/Color';
import CustomCard from '../../shared/CustomCard/CustomCard';
import formatCurrency from '../../../helper/short-currency';
const cardTitle = {
  closedDeals: 'Monthly Close Deals',
  openDeals: 'Monthly Open Deals',
  closedTasks: 'Completed Tasks',
  openTasks: 'Monthly Open Tasks',
};
const KeyMatrixCard = ({
  data,
  title,
  delta,
  loading = false,
}: {
  data: any;
  title: string;
  delta: string;
  loading?: boolean;
}) => {
  const theme = useTheme();
  // console.log(title.includes('Deals'));
  return (
    <CustomCard
      styles={{
        marginTop: { xs: '10px', xl: '16px' },
        borderRadius: '16px',
        padding: { xs: '16px', xl: '24px' },
        backgroundColor: zeplinColor.Neutral3,
        // border: `0px solid ${zeplinColor.Neutral6}`,
        // display: 'flex',
        // gap: '12px',
        // // flex: 1,
        width: '100%',
        // height: '105px',
        // alignItems: 'center',
        // flexDirection: 'column',
        // justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveDisplay6'>
              {/* {title.includes('Deal') ? '$' : ''} */}
              {title?.includes('Deals') ? `$${formatCurrency(data)}` : data !== null ? data : 'N/A'}
            </Typography>
          )}
          {title?.includes('Open Tasks') ? (
            ''
          ) : loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Chip
              label={
                <Typography
                  variant='responsiveLabel1'
                  color={zeplinColor.Neutral1}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  {delta}
                </Typography>
              }
              sx={{
                bgcolor: delta?.includes('-') ? zeplinColor.Error : zeplinColor.Green2,
                // width: '39px',
                '&.MuiChip-root': {
                  height: '22px',
                  padding: '4px 8px',
                  borderRadius: '50px',
                },
                '& .MuiChip-label': {
                  padding: 0,
                },
              }}
            />
          )}
        </Box>
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Typography variant='responsiveBody3'>{title}</Typography>
        )}
      </Box>
    </CustomCard>
  );
};

export default KeyMatrixCard;
